import { useEffect, useState } from 'react'
import { roleColumns } from './_columns'
import { useQuery } from 'react-query'
import { KTCard } from '../../../../../../_metronic/helpers'
import { initialQueryState } from '../../../../../../_metronic/helpers'
import { getUserById } from '../../../data-administration/data-admininstration-list/core/_requests'
import {
  QueryRequestProvider,
  useQueryRequest,
} from '../../../data-administration/data-admininstration-list/core/QueryRequestProvider'
import { QueryResponseProvider } from '../../../data-administration/data-admininstration-list/core/QueryResponseProvider'
import { ListViewProvider } from '../../../data-administration/data-admininstration-list/core/ListViewProvider'
import { UserEditModal } from '../../../data-administration/data-admininstration-list/form-edit-modal/CoomonEditModal'
import { UsersListHeader } from '../../../data-administration/data-admininstration-list/components/header/UsersListHeader'
import { UsersTable } from '../../../data-administration/data-admininstration-list/table/UsersTable'
const UsersList = () => {

  // const {data} = useQuery(
  //   `clients/101212/categories`,
  //   () => getUserById('', 'clients/101212/categories'),
  //   {
  //     cacheTime: 0,
  //     onError: (err) => {
  //       console.warn(err)
  //     },
  //   }
  // )
  const { updateState } = useQueryRequest()

  // const [categoriesList, setCategoriesList] = useState([{label: 'Select one', value: ''}])
  // useEffect(() => {
  //   if (data && data.length) {
  //     let dropdownData: any = []
  //     data.map((eachData) => {
  //       return dropdownData.push({label: eachData.name, value: eachData.id})
  //     })
  //     setCategoriesList(dropdownData)
  //     // updateState({
  //     //   enabled: true,
  //     //   initialApi: `categories/${dropdownData[0].value}/items`,
  //     //   ...initialQueryState,
  //     // })
  //   }
  // }, [data])

  return (
    <KTCard>
      <UsersListHeader placeholder='Search Category' label='Add new' />
      <UsersTable columnProps={roleColumns} />
      {/* <UserEditModal arrayDropdown={categoriesList} formName='ProcesingTestingModalForm' /> */}
      <UserEditModal formName='ProcesingTestingModalForm' />
    </KTCard>
  )
}

const ProductTestingWrapper = () => (
  <QueryRequestProvider initialValue={{ initialApi: 'productTestings' }}>
    <QueryResponseProvider>
      <ListViewProvider>
        <UsersList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export { ProductTestingWrapper }
